var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#C2C1C1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 0H0V100H100V0Z",
    fill: "#C2C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0112 21.1299C47.3519 21.1299 43.7542 23.6877 42.0112 24.1326C34.5475 26.1121 32.3128 31.2945 32.3128 35.298C32.3128 39.3016 32.8492 47.8425 32.8492 47.8425C30.6145 46.8194 31.2849 49.4884 31.7318 52.9582C32.4693 58.8301 33.8547 57.9626 33.8547 57.9626C34.3687 63.1672 38.0335 67.9048 38.0335 67.9048L37.2961 75.8452C33.9441 75.9119 35.7989 78.6699 34.6816 79.2482C33.5642 79.8487 33.4078 82.8737 33.4078 82.8737C0.782111 95.1068 3.9106 100 3.9106 100H96.1117C96.1117 100 99.2402 95.1068 66.6145 82.8737C66.6145 82.8737 66.4581 79.8265 65.3408 79.2482C64.2234 78.6477 66.0782 75.9119 62.7262 75.8452L61.9888 67.9048C61.9888 67.9048 64.4469 65.0133 66.1676 57.9626C66.1676 57.9626 67.5531 58.8301 68.2905 52.9582C68.7821 49.1103 69.4078 46.8194 67.1732 47.8425C67.1732 47.8425 67.5531 43.4831 67.486 39.3016C67.4637 38.6343 70.5028 38.9012 69.3408 35.3203C68.2011 31.7393 67.2849 27.847 58.3464 23.0649C55.4637 21.4858 52.6704 21.1299 50.0112 21.1299Z",
    fill: "#F9F9F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvatar);
export default __webpack_public_path__ + "static/media/no-avatar.18684d82ff491f24ba893a41553566ef.svg";
export { ForwardRef as ReactComponent };